export const BUSINESS = {
    name: "GTA Secure Inc.",
    phone: "(905) 699-2628",
    phoneHref: "tel:+19056992628",
    email: "info@gtasecure.com",
    address: {
        line1: "72 Monarch Dr.",
        line2: "Georgetown, ON L7G 0M4",
        full: "72 Monarch Dr., Georgetown, ON L7G 0M4",
    },
    logo: "https://customer-assets.emergentagent.com/job_gtasecure-staging/artifacts/ccun5gkb_gta%20secure%20inc%20logo1.PNG",
    tagline: "GTA's trusted partner for window films, security cameras, and custom blinds.",
};

export const SERVICES = [
    { key: "residential-films", label: "Residential Window Films" },
    { key: "commercial-films", label: "Commercial Window Films" },
    { key: "security-cameras", label: "Security Cameras" },
    { key: "blinds-shutters", label: "Blinds & Shutters" },
    { key: "other", label: "Something Else" },
];

export const IMAGES = {
    hero: "https://customer-assets.emergentagent.com/job_gtasecure-staging/artifacts/jwvspkv4_installation%20pic%20-%20GTA%20Secure.png",
    films: "https://images.unsplash.com/photo-1689097765651-c59617fc0cb4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBob3VzZSUyMGV4dGVyaW9yJTIwd2luZG93c3xlbnwwfHx8fDE3NzY5NzczMTR8MA&ixlib=rb-4.1.0&q=85",
    cameras: "https://images.unsplash.com/photo-1702306870714-647da7044224?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHw0fHxzZWN1cml0eSUyMGNhbWVyYSUyMGluc3RhbGxhdGlvbiUyMGhvdXNlfGVufDB8fHx8MTc3Njk3NzMxNHww&ixlib=rb-4.1.0&q=85",
    blinds: "https://images.unsplash.com/photo-1771109826143-1281f4d09fbc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjB3aW5kb3clMjBibGluZHMlMjBpbnRlcmlvcnxlbnwwfHx8fDE3NzY5NzczMTR8MA&ixlib=rb-4.1.0&q=85",
    gallery: [
        "https://customer-assets.emergentagent.com/job_gtasecure-staging/artifacts/jwvspkv4_installation%20pic%20-%20GTA%20Secure.png",
        "https://customer-assets.emergentagent.com/job_gtasecure-staging/artifacts/iw4sjun5_windows%20securit%20film%202.png",
        "https://customer-assets.emergentagent.com/job_gtasecure-staging/artifacts/0z7ui3we_commercial%20installation%20gta%20security.png",
        "https://customer-assets.emergentagent.com/job_gtasecure-staging/artifacts/9mh406pm_zebra%20blinds%20gta%20secure.png",
        "https://customer-assets.emergentagent.com/job_gtasecure-staging/artifacts/zkv58ykf_installation%20pic%20-%20GTA%20Secure.png",
    ],
};
